import { useCallback, useRef } from "react";

export const VARIABLE_BARRA_INFERIOR = "--alto-barra-inferior";

// useBarraInferior publica la altura de una barra fija abajo (el botón de
// compra en mobile) para que el aviso de cookies se ubique encima y no la tape.
export const useBarraInferior = () => {
  const observador = useRef(null);

  return useCallback((nodo) => {
    const raiz = document.documentElement;
    observador.current?.disconnect();
    observador.current = null;
    if (!nodo) {
      raiz.style.removeProperty(VARIABLE_BARRA_INFERIOR);
      return;
    }
    const medir = () => raiz.style.setProperty(VARIABLE_BARRA_INFERIOR, `${nodo.offsetHeight}px`);
    medir();
    if (typeof ResizeObserver !== "undefined") {
      observador.current = new ResizeObserver(medir);
      observador.current.observe(nodo);
    }
  }, []);
};
